var map = {
	"./svg.polyfill.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/polyfills/svg.polyfill.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/opt/app/client/src/site__fus078/polyfills nonrecursive /.*\\.polyfill.js$/";


//////////////////
// WEBPACK FOOTER
// ./client/src/site__fus078/polyfills nonrecursive .*\.polyfill.js$
// module id = /opt/app/client/src/site__fus078/polyfills nonrecursive /.*\.polyfill.js$/
// module chunks = site__fus078